import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getAlertsSaga(action: types.GetAlertsActionType) {
  try {
    const response = yield call(services.getAlertsService, action.payload);
    yield put({ type: actions.GET_ALERTS_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_ALERTS_ERROR, response: error });
    toastr.error("Alerts Not Loaded", `${error.error.message}`);
  }
}
